import { gql } from "@apollo/client"
import { QUALITY_BASE_FRAG } from "graphql/quality.gql"

const BATCH_FRAG = gql`
  fragment BatchFrag on WeighBatchType {
    id
    skuCount
    skuType {
      id
      name
    }
    uomType {
      id
      codename
      name
    }
    uomCount
    codename
    skuTareWeight
    grossWeight
    netWeight
    tareWeight
  }
`
const WEIGH_SCHEDULE_FRAG = gql`
  fragment WeighScheduleFrag on ScheduleType {
    id
    gatelogsSet {
      id
      createdAt
      gateEntryNo
      gateStatus
      gateNumber {
        id
        name
        codename
      }
    }
    date
    requiredQuantity
    scheduledIn {
      id
      packagingMaterialFlow
    }
    unloadingLocation {
      id
      name
    }
    unloadingSubLocation {
      id
      name
    }
    packagingMaterial {
      id
      createdAt
      fieldSupervisorName {
        id
        fullName
      }
      packagingMaterialItems {
        id
        receivedQuantity
      }
      netWeightAfterDeduction
      totalReceivedQuantity
    }
    skuType {
      id
      name
      capacity
      selfWeight
      capacityUnit {
        id
        name
        codename
      }
    }
    cropGroup {
      id
      name
      codename
    }
    farmQuantityUnit {
      id
      name
      codename
    }
    plotCommodity {
      name
      id
      referenceId
    }
    gradePrices {
      id
      grade {
        id
        name
      }
    }
    pricingDoneOn
    transportDetail {
      id
      standardDeduction
    }
    variety {
      id
      name
      packagingMaterialFlow
      commodity {
        id
        name
      }
    }
    farmWeight
    gatePass
    aggregator {
      id
      fullName
    }
    plot {
      id
      codename
      name
      farmer {
        id
        fullName
        username
        isBlocked
      }
      address {
        id
        village
      }
    }
  }
`

const BATCH_WEIGH_FRAG = gql`
  fragment BatchWeighFrag on WeighType {
    id
    date
    grade {
      id
    }
    status
    farmWeight
    grossWeight
    tareWeight
    netWeight
    finalWeight
    invoicingDoneOn
    standardDeduction
    inwardedQuantity
    batches {
      ...BatchFrag
    }
  }
  ${BATCH_FRAG}
`

const BULK_WEIGH_FRAG = gql`
  fragment BulkWeighFrag on WeighType {
    id
    status
    updatedAt
    grade {
      id
      name
    }
    skuType {
      id
      name
    }
    farmWeight
    grossWeight
    tareWeight
    inwardedQuantity
    standardDeduction
    netWeight
    weightLoss
    finalWeight
  }
`

const INWARD_FRAG = gql`
  fragment InwardFrag on InwardType {
    id
    grn
    grade {
      id
      name
      specifications
    }
    quality {
      ...QualityBaseFrag
    }
    weigh {
      ...BatchWeighFrag
    }
  }
  ${BATCH_WEIGH_FRAG}
  ${QUALITY_BASE_FRAG}
`
const INWARD_QUALITY_FRAG = gql`
  fragment InwardQualityFrag on InwardType {
    id
    grade {
      id
      name
      specifications
    }
    quality {
      ...QualityBaseFrag
    }
  }
  ${QUALITY_BASE_FRAG}
`
const BATCH_INWARD_FRAG = gql`
  fragment BatchInwardFrag on InwardType {
    id
    serialNo
    rstNo
    grn
    ...InwardQualityFrag
    weigh {
      id
      inwardedQuantity
      farmWeight
      weightLoss
      netWeight
      status
      standardDeduction
      batches {
        ...BatchFrag
      }
    }
  }
  ${BATCH_FRAG}
  ${INWARD_QUALITY_FRAG}
`

const TRIP_DETAIL_FRAG = gql`
  fragment TripDetailFrag on TripType {
    id
    status
    expense
    unloadedBy {
      id
      name
      contact
    }
    weighDetail {
      ...BulkWeighFrag
    }
    bookings {
      id
      qualitySample {
        ...QualityBaseFrag
      }
      inwards {
        ...BatchInwardFrag
      }
      schedule {
        ...WeighScheduleFrag
      }
    }
  }
  ${BULK_WEIGH_FRAG}
  ${WEIGH_SCHEDULE_FRAG}
  ${BATCH_INWARD_FRAG}
  ${QUALITY_BASE_FRAG}
`
export {
  BATCH_WEIGH_FRAG,
  BULK_WEIGH_FRAG,
  WEIGH_SCHEDULE_FRAG,
  INWARD_FRAG,
  INWARD_QUALITY_FRAG,
  BATCH_FRAG,
  TRIP_DETAIL_FRAG,
  BATCH_INWARD_FRAG,
}
